import { useTranslation } from "react-i18next";

const LANG_BASE = "vessel-call.operations";

const CargoOperations = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="operations-liquid-bulk-cargo-operations" className="w-full py-4">
      <h3 className="text-base font-semibold">{t(`${LANG_BASE}.cargo-operations`)}</h3>
    </div>
  );
};

export default CargoOperations;
